import React from 'react';

const FaqTextWithLink = ({ link }) => (
  <p>
    {link.leadingText}
    <a className="faq__panel--link" href={link.href}>
      {' '}
      {link.title}{' '}
    </a>
    {link.trailingText}
  </p>
);

export default FaqTextWithLink;



// WEBPACK FOOTER //
// ./src/components/Static/SFFleets/Shared/FaqTextWithLink.js